exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.svg-icon[data-v-431f8e80] {\r\n    width: 1em;\r\n    height: 1em;\r\n    vertical-align: -0.15em;\r\n    fill: currentColor;\r\n    overflow: hidden;\n}\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-431f8e80","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/core/SvgIcon/index.vue
// module id = WRG1
// module chunks = 78